import http from '@/js/Http'
import {AxiosOptions} from 'guaxinim-web'

export default {
  create(entity) {
    const url = `/pessoa/`
    return new Promise((resolve, reject) => {
      http.post(url, entity).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  edit(id, entity) {
    const url = `/pessoa/${id}`
    return new Promise((resolve, reject) => {
      http.put(url, entity).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDTOByID(id) {
    const url = `/pessoa/dto/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDTOs(ids, filterparams) {
    const params = {
      ids,
      filterparams
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/pessoa/dto`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEntities(ids) {
    const params = {
      ids
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/pessoa/`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEntityByID(id) {
    const url = `/pessoa/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findPessoaFinderDTO(ids, busca, limite) {
    const params = {
      ids,
      busca,
      limite
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/pessoa/finder`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findPessoaFinderDTOByID(id) {
    const url = `/pessoa/finder/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getDtoPresentation() {
    const url = `/pessoa/dto/presentation`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getPresentation() {
    const url = `/pessoa/presentation`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  newEntity() {
    const url = `/pessoa/new`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  remove(id) {
    const url = `/pessoa/${id}`
    return new Promise((resolve, reject) => {
      http.delete(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  }
}